import { render, staticRenderFns } from "./TqImagesSlider.vue?vue&type=template&id=3c751d13&scoped=true&"
import script from "./TqImagesSlider.vue?vue&type=script&lang=js&"
export * from "./TqImagesSlider.vue?vue&type=script&lang=js&"
import style0 from "./TqImagesSlider.vue?vue&type=style&index=0&id=3c751d13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c751d13",
  null
  
)

export default component.exports